if ( typeof ProductPage !== 'function' ) {

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');

			// Gallery thumbnails

			if ( this.productSlider ) {

				const productGaleryThumbnails = this.querySelector('.product-gallery__thumbnails-holder');

				if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
						if ( i == 0 )  {
							elm.classList.add('active');
						}
						elm.addEventListener('click',e=>{
							if ( this.productSlider.sliderEnabled ) {
								this.productSlider.changeSlide(e.currentTarget.dataset.index);
							} else {
								window.scrollTo({
									top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).offsetTop + this.offsetTop,
									behavior: 'smooth'
								});
								this.thumbnailNavigationHelper(e.currentTarget.dataset.index);
							}
							this._pauseAllMedia();
							this._playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`));
							productGaleryThumbnails.scrollTo({
								left: elm.offsetLeft - 50,
								behaviour: 'smooth'
							})
						});
					})

					this.productSlider.addEventListener('change', e=>{
						this.thumbnailNavigationHelper(e.target.index);
					});

				}

				this.productSlider.addEventListener('navigation', e=>{
					this._playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`));
				})
				this.productSlider.addEventListener('change', e=>{
					this._pauseAllMedia();
					if ( this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType == 'model' ) {
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId);
						}
						setTimeout(()=>{
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				// Parallax

				this.productSlider.addEventListener('ready', (e)=>{
					
					if ( this.firstProductGalleryIndex ) {
						this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
					}

					const productSlides = this.productSlider.querySelectorAll('.product-gallery-item');
					const productFigures = this.querySelectorAll('.apply-gallery-animation');
					this.productSlider.addEventListener('scroll', ()=>{
						const scrollX = -this.productSlider.element.scrollLeft;
						productSlides.forEach((slide,i)=>{
							const media = productFigures[i];
							if ( media ) {
								media.style.transform = `translateX(${( slide.offsetLeft + scrollX ) * -1/3}px)`;
							}
						});
					});

				});

			}

			// show cart drawer when element is added to cart

			if ( ! document.body.classList.contains('template-cart') && KROWN.settings.cart_action == 'overlay' ) {
				
				let addToCartEnter = false;
				if ( this.querySelector('[data-js-product-add-to-cart]') ) {
					this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							addToCartEnter = true;
						}
					})
				}	

				if ( this.querySelector('[data-js-product-form]') ) {
					this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
						document.getElementById('site-cart-sidebar').show();
						if ( document.getElementById('cart-recommendations') ) {
							document.getElementById('cart-recommendations').generateRecommendations();
						}
						if ( addToCartEnter ) {
							setTimeout(()=>{
								document.querySelector('#site-cart-sidebar [data-js-close]').focus();
							}, 200);
						}
					});
				}

			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			// hide buy now button if stock disabled

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart]');
			if ( addToCartButton ) {
				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				const buyObserver = new MutationObserver(()=>{
					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
			}


			// Product variant event listener for theme specific logic

			this.productVariants = this.querySelector('product-variants[data-main-product-variants]');
			if ( this.productVariants ) {
				this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
				this.onVariantChangeHandler({target:this.productVariants});
			}

		}

		thumbnailNavigationHelper(index=0){
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
				if ( i == index )
					elm.classList.add('active');
				else 
					elm.classList.remove('active');
			});
		}

		onVariantChangeHandler(e){

			let variant = e.target.currentVariant;
			if ( variant ) {
				
				// image handling

				if ( variant.featured_media != null ) {
					let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
					if ( variantImg ) {
						if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
							if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
								this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
							} else {
								this.firstProductGalleryIndex = variantImg.dataset.index;
							}
						} else {
							window.scrollTo({
								top: variantImg.offsetTop,
								behavior: 'smooth'
							});
						}
					}
				}

			}
			
		}

		_pauseAllMedia(){

			document.querySelectorAll('.product-gallery .js-youtube').forEach(video => {
				video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
			});
			document.querySelectorAll('.product-gallery .js-vimeo').forEach(video => {
				video.contentWindow.postMessage('{"method":"pause"}', '*');
			});
			document.querySelectorAll('.product-gallery video').forEach(video => video.pause());
			document.querySelectorAll('.product-gallery product-model').forEach(model => {
				if ( model.modelViewerUI ) 
					model.modelViewerUI.pause()
			});
		}
		
		_playMedia(media){
			switch ( media.dataset.productMediaType ) {
				case 'video':
					if ( media.querySelector('video') ) {
						media.querySelector('video').play();
					}
					break;
				case 'external_video-youtube':
					if ( media.querySelector('.js-youtube') ) {
						media.querySelector('.js-youtube').contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
					}
					break;
				case 'external_video-vimeo':
					if ( media.querySelector('.js-vimeo') ) {
						media.querySelector('.js-vimeo').contentWindow.postMessage('{"method":"play"}', '*');
					}
					break;
			}
		}

	}

  if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}

// Sticky Quantity Selector with Sync Functionality
class StickyQuantitySelector {
  constructor() {
    this.init();
  }

  init() {
    // Initialize all sticky quantity selectors
    document.querySelectorAll('.sticky-add-to-cart').forEach(cart => {
      this.setupQuantitySync(cart);
    });
  }

  setupQuantitySync(container) {
    const stickyQuantitySelect = container.querySelector('[data-js-sticky-quantity]');
    const mainQuantitySelect = document.querySelector('.product-quantity__selector');
    const addToCartButton = container.querySelector('[data-js-atc]');

    if (!stickyQuantitySelect) return;

    // Sync sticky selector with main selector on page load
    if (mainQuantitySelect) {
      stickyQuantitySelect.value = mainQuantitySelect.value;
    }

    // Handle sticky selector changes - update main selector
    stickyQuantitySelect.addEventListener('change', () => {
      if (mainQuantitySelect) {
        mainQuantitySelect.value = stickyQuantitySelect.value;
        
        // Trigger change event on main selector in case other scripts listen to it
        const changeEvent = new Event('change', { bubbles: true });
        mainQuantitySelect.dispatchEvent(changeEvent);
      }
    });

    // Handle main selector changes - update sticky selector
    if (mainQuantitySelect) {
      mainQuantitySelect.addEventListener('change', () => {
        stickyQuantitySelect.value = mainQuantitySelect.value;
      });
    }

    // Handle add to cart functionality
    if (addToCartButton) {
      addToCartButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.addToCart(container, stickyQuantitySelect.value);
      });
    }
  }

  addToCart(container, quantity) {
    // Get variant ID from the main product form or current variant
    const productForm = document.querySelector('[id*="product-form"]');
    const variantIdInput = productForm?.querySelector('input[name="id"]');
    const variantId = variantIdInput?.value || window.currentVariantId;
    
    if (!variantId) {
      console.error('No variant ID found for add to cart');
      return;
    }

    const formData = {
      'items': [{
        'id': parseInt(variantId),
        'quantity': parseInt(quantity)
      }]
    };

    // Show loading state
    const button = container.querySelector('[data-js-atc]');
    if (button) {
      button.classList.add('button--loading');
      button.disabled = true;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      console.log('Added to cart:', data);
      
      // Trigger cart update events that your theme might be listening for
      document.dispatchEvent(new CustomEvent('cart:updated'));
      
      // Update cart count/drawer if your theme has these functions
      if (typeof updateCartCount === 'function') {
        updateCartCount();
      }
      if (typeof refreshCart === 'function') {
        refreshCart();
      }
      
      // Show success feedback (you might want to customize this)
      this.showSuccessMessage(container);
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      this.showErrorMessage(container, 'Er is een fout opgetreden. Probeer het opnieuw.');
    })
    .finally(() => {
      // Remove loading state
      if (button) {
        button.classList.remove('button--loading');
        button.disabled = false;
      }
    });
  }

  showSuccessMessage(container) {
    // Simple success indication - you can customize this
    const button = container.querySelector('[data-js-atc]');
    if (button) {
      const originalText = button.querySelector('.button__text').textContent;
      button.querySelector('.button__text').textContent = 'Toegevoegd!';
      
      setTimeout(() => {
        button.querySelector('.button__text').textContent = originalText;
      }, 2000);
    }
  }

  showErrorMessage(container, message) {
    // Simple error indication - you can customize this
    const button = container.querySelector('[data-js-atc]');
    if (button) {
      const originalText = button.querySelector('.button__text').textContent;
      button.querySelector('.button__text').textContent = 'Fout opgetreden';
      button.style.backgroundColor = '#dc3545';
      
      setTimeout(() => {
        button.querySelector('.button__text').textContent = originalText;
        button.style.backgroundColor = '';
      }, 3000);
    }
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new StickyQuantitySelector();
});

// Also initialize when the sticky cart becomes visible (in case it's loaded dynamically)
if (window.MutationObserver) {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1 && node.querySelector && node.querySelector('.sticky-add-to-cart')) {
          new StickyQuantitySelector();
        }
      });
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}